<template>
  <div :class="titleClass">
    <slot />
  </div>
</template>

<script>
/**
 * Title component
 */
export default {
  // set component name
  name: "r-title",

  // computed props
  computed: {
    /**
     * Component calculated classes
     */
    titleClass() {
      return {
        "text-2xl": true,
        "md:text-3xl": true,
        "font-bold": true
      }
    }
  }
}
</script>
